// extracted by mini-css-extract-plugin
module.exports = {"ArrowButton":"ArrowButton_ArrowButton__H6W43","icon":"ArrowButton_icon__315ot"};